import { HttpErrorResponse, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestMethod } from '@api/abstracts/models';
import { environment } from '@environments/environment';
import { mock } from '@mock/mock';
import { Mock } from '@mock/model';
import { delay, map, Observable, of, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MockService {
  isActivated: boolean = environment.isMockEnabled;

  getMockResponse(
    method: keyof typeof RequestMethod,
    url: string,
    realResponse: () => Observable<HttpEvent<unknown>>
  ): Observable<HttpEvent<unknown>> | undefined {
    const schema: Mock | undefined = this.findSchema(method, url);
    if (!schema) return undefined;

    const { patch } = schema;
    if (patch) {
      return realResponse().pipe(
        map((event) => (event instanceof HttpResponse ? event.clone({ body: patch(event.body) }) : event))
      );
    }

    const { status = 200, schema: body, delay: mockDelay = 0 } = schema;
    const isError = status >= 400 && status < 600;

    const response$ = isError
      ? throwError(
          () =>
            new HttpErrorResponse({
              error: 'Error simulated by the mock.',
              status,
              statusText: 'Error simulated by the mock.',
            })
        )
      : of(
          new HttpResponse({
            status,
            body,
          })
        );

    return mockDelay > 0 ? response$.pipe(delay(mockDelay)) : response$;
  }

  private findSchema(method: keyof typeof RequestMethod, url: string): Mock | undefined {
    return mock.find((schema) => {
      const endpoint = environment.API.endpoint[schema.apiEndpoint ?? 'default'];
      const isMatchingMethod = method === 'GET' ? !schema.method || schema.method === method : schema.method === method;
      const isMatchingURL = schema.useStartsWith
        ? url.startsWith(`${endpoint}/${schema.url}`)
        : `${endpoint}/${schema.url}` === url;
      return isMatchingMethod && isMatchingURL;
    });
  }
}
